//* 组件属性
import type { HomeData } from "./types";
export const useOptions = (data: Ref<HomeData>) => {
    //* 获取i18n
    const i18n = useI18n();

    return {
        type: {
            tool: "Tool",
            gene: "Gene",
            model: "Model",
            disease: "Disease",
            mutation: "Mutation",
        } as { [name: string]: string },

        //* 统计数据
        statistics: [
            {
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/5d08b648-1b20-4b6c-82de-16b7b8db3a8d.webp",
                name: i18n.t("Layout.TypeRecords", { type: "Diseases" }),
                route: "SearchDisease",
                color: "#833aae",
                count: data.value?.statistics.disease.total || 0,
            },
            {
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/cc18060c-0efb-40ce-8b10-48cd90017275.webp",
                name: i18n.t("Layout.TypeRecords", { type: "Genes" }),
                route: "SearchGene",
                color: "#00c3ce",
                count: data.value?.statistics.gene.total || 0,
            },
            {
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/c39aa95e-42df-40ef-9c5e-05ece46b7940.webp",
                name: i18n.t("RecordsMutations"),
                route: "SearchMutation",
                color: "#0051d4",
                count: (data.value?.statistics.mutation.total || 0) / (i18n.locale.value == "zh" ? 10000 : 1000000),
                decimals: i18n.locale.value == "zh" ? 0 : 1,
                unit: i18n.locale.value == "zh" ? "万" : "Million",
            },
            {
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/79176625-00ed-4101-8bdb-30445fb65483.webp",
                name: i18n.t("Layout.TypeRecords", { type: "AnimalModels" }),
                route: "SearchModel",
                color: "#0051d4",
                count: data.value?.statistics.model.total || 0,
            },
        ],

        //* 推荐工具
        tools: reactive([
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/78908fbd-0b67-4e8c-a347-18e5b8ea6c2e.webp",
                name: i18n.t("VPP"),
                label: "Pathogenicity Predictor",
                route: { name: "Pathogenicity" },
                mask: false,
                descript: i18n.t("PathoPredictDescribe"),
            },
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/222cab08-a6b0-40a6-a74a-e04b4505a065.webp",
                name: i18n.t("RNASplicer"),
                label: "RNA Splicer",
                route: { name: "RnaSplicer" },
                mask: false,
                descript: i18n.t("RNASplicerDescribe"),
            },
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/da2f6128-1c99-44d5-8bc4-af35e14e6df2.webp",
                name: i18n.t("SequenceAlignment"),
                label: "Sequence Alignment",
                route: { name: "SequenceAlignment" },
                mask: false,
                descript: i18n.t("SequenceAlignmentDescribe"),
            },
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/9a1251ca-d2e7-4708-b843-914b31ee76aa.webp",
                name: i18n.t("MutationViewer"),
                label: "Mutation Direct",
                route: { name: "BioVariant" },
                mask: false,
                descript: i18n.t("MutationViewerDescribe"),
            },
            {
                img: "https://rdgta.cdn.cyagen.com/rddc/pictures/d3e245fd-1171-485c-90ca-ef3d747c3cab.webp",
                name: i18n.t("SequenceViewer"),
                label: "Sequence Viewer",
                route: { name: "BioSequence" },
                mask: false,
                descript: i18n.t("SequenceViewerDescribe"),
            },
        ]),

        //* 特色
        features: [
            {
                route: { name: "TimelyUpadated" },
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/6035f768-fdfc-497b-bd61-4e81ceb2827d.webp",
                name: i18n.t("Home.Module3Card1Name"),
                descript: i18n.t("Home.Module3Card1Descript"),
                background: "#8D7BBF",
            },

            {
                route: { name: "DataVisualization" },
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/76eb3a96-eb4a-4571-96d5-dbbc61befa03.webp",
                name: i18n.t("Home.Module3Card2Name"),
                descript: i18n.t("Home.Module3Card2Descript"),
                background: "#C8AA7B",
            },

            {
                route: { name: "DataSimplication" },
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/588a9114-1a7e-4490-9826-5a88157ca51c.webp",
                name: i18n.t("Home.Module3Card3Name"),
                descript: i18n.t("Home.Module3Card3Descript"),
                background: "#74A5B6",
            },
            {
                route: { name: "AllInOne" },
                icon: "https://rdgta.cdn.cyagen.com/rddc/pictures/4619c25e-893b-4b19-a2f0-4f94cb782aa3.webp",
                name: i18n.t("Home.Module3Card4Name"),
                descript: i18n.t("Home.Module3Card5Descript"),
                background: "#72AA8E",
            },
        ],
    };
};
